import React from 'react';
import * as Sentry from '@sentry/react';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router';

import { getEnvironmentVariables } from '~/environment';

function maybeInitSentry() {
  const env = getEnvironmentVariables();

  if (!env.isDeployed && !env.useSentry) {
    console.log('Sentry is disabled locally');
    return;
  }

  const baseConfig = {
    environment: env.environment,
    release: env.packageFqn,
    enableLogs: true,
    sendDefaultPii: false,
    debug: false, // Set to true to enable debug logging from the Sentry SDK itself.
  };

  Sentry.init({
    ...baseConfig,
    dsn: 'https://ee884aeaa16d05a3e2af2e43dabb9064@o4510223965552640.ingest.us.sentry.io/4510223982657536',
    integrations: [
      // Send console.debug, console.info, console.warn, and console.error calls as logs to Sentry.
      // This may be useful for third-party libraries that use the console API directly.
      Sentry.consoleLoggingIntegration({ levels: ['info', 'warn', 'error'] }),
      // Integrate with React Router v7 to automatically capture rendering errors.
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    beforeSendLog: (log) => {
      if (log.level === 'debug') {
        return null; // Do not send debug logs to Sentry.
      }
      return log;
    },
  });

  console.log('Sentry is initialized', { baseConfig });
}

maybeInitSentry();
